import React, { useState, useEffect } from 'react';
import '../Dashboardui/SalesData.css';
import useApi from '../../../../utils/api-manager/Helper/useApi';

function SalesData() {
  const [data, setData] = useState({ totalItemsSold: 0, totalSales: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { Post } = useApi();

  const getStartAndEndDate = () => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const start_date = `${currentYear}-01-01`; 
    const end_date = `${currentYear}-12-31`;  

    return { start_date, end_date };
  };

  useEffect(() => {
    const { start_date, end_date } = getStartAndEndDate(); 

    Post('totalSalesAndItems', { start_date, end_date })
      .then((response) => {
        const responseData = response.data || {}; 
        setData({
          totalSales: responseData.total_sales || 0,
          totalItemsSold: responseData.total_items_sold || 0,
        });
        setLoading(false); 
      })
      .catch((error) => {
        setError(error.message); 
        setLoading(false); 
      });
  }, []); 

  return (
    <div className="SalesData">
      <div className="">
        {loading ? (
          <div className="main-card">
            <h2 style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontStyle: 'italic',
            color: '#999',
          }}>Loading...</h2>
         
          </div>
        ) : error ? (
          <div className="main-card">
            <h2 style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontStyle: 'italic',
            color: '#999',
          }}>Error: {error}</h2>
          </div>
        ) : data.totalItemsSold === 0 && data.totalSales === 0 ? (
          <div className="main-card" style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '200px', // adjust as needed
          }}>
            <p style={{
              fontWeight: '100',
              fontSize: '16px',
              color: '#999',
              textAlign: 'center',
              fontStyle: 'italic',
              margin: 0
            }}>
              No data available
            </p>
          </div>
          
        ) : (
          <div className="main-card">
            <div style={{marginTop:'30px'}}>
              <h2>Total Items Sold</h2>
              <p>{data.totalItemsSold}</p>
              <br />
              <h2>Total Sales</h2>
              <p>{data.totalSales > 0 ? data.totalSales.toLocaleString() : '0'}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SalesData;
